import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { skipAPay } from '../../services/api';
import { SideMenu, TopMenu } from 'maxcu-shared-lib';
import menuItems from '../SideMenu/menuItems';

function Review() {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedLoan, selectedAccount } = location.state || {};

  useEffect(() => {
    document.title = 'Skip a Pay | MAX Credit Union';
  }, []);

    const [isCollapsed, setIsCollapsed] = useState(false);



  const handleResize = () => {
    if (window.innerWidth < 600) {
      setIsCollapsed(true);
    } else {
      setIsCollapsed(false);
    }
  };

  useEffect(() => {
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (!selectedLoan || !selectedAccount) {
      navigate('/');
    }
  }, [selectedLoan, selectedAccount, navigate]);

  const [
    loanId,
    loanDescription,
    dueDate,
    maturityDate,
    paymentAmount,
    futureDueDate,
    futureMaturityDate,
    ltloc
  ] = selectedLoan ? selectedLoan.split(':') : [];

  const [accountId, accountDescription, accountBalance] = selectedAccount ? selectedAccount.split(':') : [];

  const handleSubmit = async () => {
    const dataToPass = {
      loanId,
      loanDescription,
      dueDate,
      maturityDate,
      paymentAmount,
      futureDueDate,
      futureMaturityDate,
      ltloc,
      accountId,
      accountDescription,
      accountBalance
    };
    
    try {
      await skipAPay(dataToPass);
      navigate('/Submit', {
        state: dataToPass
      });
    } catch (error) {
      // Handle error appropriately
    }
  };

  if (!selectedLoan || !selectedAccount) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {isCollapsed && <TopMenu />}
      <div style={{ display: 'flex', flex: 1 }}>
        <SideMenu menuItems={menuItems} />
        <div style={{ flex: 1, padding: '20px 20px 20px 260px', overflow: 'auto' }}>
          <style type="text/css">
            {`
              .btnwrapper {padding: 20px;}
              .ctr {text-align: center;}
              q2-btn {width: 40%;}
              body {}
              p {font-size: medium; font-weight: normal;}
              h1, h2, h3, h4, h5, h6 {font-size: large; font-weight: bold; color: #3b8ede;}

              .select-container {
                  display: flex;
                  gap: 10px;
              }

              .custom-select {
                  width: 50%; /* Takes up half of the page width */
              }

              /* Responsive image style */
              img {
                  max-width: 100%;
                  height: auto;
                  display: block;
                  margin: 0 auto;
              }

              @media screen and (max-width: 768px) {
                div[style*="padding: 20px 20px 20px 260px"] {
                  padding: 20px 20px 20px 60px !important;
                }
              }
            `}
          </style>

          <img src="/SkipAPayHeaders-2.png" alt="Banner Image" />

          <header>
            <div>
              <h3><br />Please confirm that the following information is correct</h3>

              <p>You chose to skip this loan: LN{loanId} - {loanDescription}</p>
              <p>Your monthly payment for the loan is: ${paymentAmount}</p>
              <p>Your next payment is due on this date: {dueDate}</p>
              <p>Your new loan maturity date will be: {futureMaturityDate}</p>
              <p>Your Skip A Pay fee is $35 and will be paid from account: {accountId} - {accountDescription}</p>

              <button 
                onClick={handleSubmit}
                style={{
                  padding: '10px 20px',
                  fontSize: '1.2rem',
                  backgroundColor: '#1e3a8a',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                Submit
              </button>

              <input type="hidden" id="routing_key" name="routing_key" value="submit" />
            </div>
          </header>


        </div>
      </div>
    </div>
  );
}

export default Review;